export default __webpack_public_path__ + "static/media/loading.b9ea34bd.svg";